import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.css';
import { DialogActions, Button, Grid, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

function DateLimitDialog({ handleClose, title, message }) {
  const { t: tCommon } = useTranslation('common');
  const { t: tPopup } = useTranslation('popup');
  return (
    <div className={styles.popUp}>
      <div className={styles.contentWrapper} style={{ maxWidth: 600 }}>
        <div className={styles.headSec}>
          <h2 className={styles.editTitle}>{title || tPopup('Date Range Limit Exceeded')}</h2>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </div>
        <div className={styles.inputSec}>
          <Grid container className={styles.inputRow}>
            <Grid item xs={12}>
              <span>
                {message ||
                  tPopup('Reports can only be generated for up to 3 months. Please select a range within 3 months.')}
              </span>
            </Grid>
          </Grid>
          <DialogActions>
            <Button
              variant="contained"
              size="small"
              sx={{bgcolor: '#00a65a',
                '&:hover': {
                  bgcolor: '#00a65a',
                }  }}
              onClick={handleClose}
            >
              {tCommon('Ok')}
            </Button>
          </DialogActions>
        </div>
      </div>
    </div>
  );
}

export default DateLimitDialog;
